import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DeployBotState } from './types'

export const initialState: DeployBotState = {
  deploying: false,
  deployError: undefined,
  botIdsForPossibleResumeHosting: []
}

const slice = createSlice({
  name: 'deployBot',
  initialState,
  reducers: {
    deployBot: state => {
      state.deployError = undefined
      state.deploying = true
    },
    deployBotSuccess: state => {
      state.deploying = false
    },
    deployBotFailure: (state, action: PayloadAction<string>) => {
      state.deploying = false
      state.deployError = action.payload
    },
    setIsDeploying: (state, action: PayloadAction<boolean>) => {
      state.deploying = action.payload
    },
    setBotIdForPossibleResumeHosting: (state, action: PayloadAction<string>) => {
      const botId = action.payload
      if (!state.botIdsForPossibleResumeHosting.includes(botId)) {
        state.botIdsForPossibleResumeHosting.push(botId)
      }
    },
    unsetBotIdForPossibleResumeHosting: (state, action: PayloadAction<string>) => {
      const botId = action.payload
      state.botIdsForPossibleResumeHosting = state.botIdsForPossibleResumeHosting.filter(
        currentBotId => currentBotId !== botId
      )
    }
  }
})

export const reducer = slice.reducer
export const actions = slice.actions
